
import { Crown } from "lucide-react";

interface RankDisplayProps {
  rank: number;
}

export const RankDisplay = ({ rank }: RankDisplayProps) => {
  // If rank is 0 or undefined/null, show a dash
  if (!rank) return <span className="text-xl font-bold text-muted-foreground">-</span>;
  
  // First place gets a crown
  if (rank === 1) return <Crown className="h-6 w-6 text-[#FFD700] fill-[#FFD700]" />;
  
  // Second place
  if (rank === 2) return <span className="text-xl font-bold text-[#C0C0C0]">2nd</span>;
  
  // Third place
  if (rank === 3) return <span className="text-xl font-bold text-[#CD7F32]">3rd</span>;
  
  // All other ranks
  return <span className="text-xl font-bold text-muted-foreground">#{rank}</span>;
};
